// extracted by mini-css-extract-plugin
export default {"catalog":"styles_catalog__mQ1VD","container":"styles_container__2Hlg1","wrapper":"styles_wrapper__4sklI"};